module.exports = __webpack_public_path__ + "img/logo.f92943e7.svg";